import { createContext, useContext } from "react";
import type { RyftAccountGetResponseType } from "@sellar-io/api-v2/types";

export type RyftNonHostedDashboardAccountContext = {
  account: RyftAccountGetResponseType;
};

export const RyftNonHostedDashboardAccountContext =
  createContext<RyftNonHostedDashboardAccountContext | null>(null);

export const useRyftNonHostedDashboardAccount = () => {
  const context = useContext(RyftNonHostedDashboardAccountContext);

  if (!context) {
    throw new Error(
      "useRyftNonHostedDashboardAccount() must be used within <RyftNonHostedDashboardAccountProvider />",
    );
  }

  return context;
};
